module.exports = __webpack_public_path__ + "static/media/ico-user.82378ed6.svg";